import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LocaleSetting } from '../models/LocaleSettings';
import { Logger } from './logger.service';
// import { UserService } from './modelServices/user.service';
// import { User } from '../classes/user';
import * as _ from 'lodash';
/**
 * Service that handles the language settings
 */
var LanguageService = (function () {
    /**
     * Constructor
     * @param {TranslateService} translate Translate service
     */
    function LanguageService(translate) {
        // if (userService.isLoggedIn()) {
        //   this.userService.getUser().then(user => {
        //     if (user['language'] && user['language']['shortName']) {
        //       this.userLanguage = user['language']['shortName'].toLowerCase();
        //       this.initLanguage();
        //     }
        //   });
        // } else {
        // Logger.log(translate);
        this.translate = translate;
        /**
         * Default language
         * @type {string}
         */
        this.defaultLanguage = 'de';
        /**
         * User language defined by browser language
         * @type {string}
         */
        this.userLanguage = navigator.language || navigator['userLanguage'] || this.defaultLanguage;
        /**
         * List with valid languages
         * @type {any[]}
         */
        this.validLanguages = [
            {
                long: 'de-DE',
                short: 'de',
                display: 'Deutsch',
                id: 2,
            },
            {
                long: 'en-US',
                short: 'en',
                display: 'English (USA)',
                id: 1,
            },
            {
                long: 'en-GB',
                short: 'en',
                display: 'English (UK)',
                id: 1,
            },
        ];
        /**
         * Current selected language
         * @type {any}
         */
        this.currentLanguage = this.validLanguages[0];
        // this.initLanguage();
        // }
    }
    /**
     * Initiate the language settings
     */
    LanguageService.prototype.initLanguage = function () {
        if (this.userLanguage && this.isValidLanguage(this.userLanguage)) {
            this.translate.use(this.userLanguage);
            this.currentLanguage = this.getLanguage(this.userLanguage);
        }
        else {
            this.translate.use(this.defaultLanguage);
            this.currentLanguage = this.getLanguage(this.defaultLanguage);
        }
        moment.locale(this.currentLanguage.short);
        // this.validLanguages.sort(Tools.compare('long', null, false));
        this.translate.setDefaultLang(this.defaultLanguage);
        var languageList = [];
        for (var _i = 0, _a = this.validLanguages; _i < _a.length; _i++) {
            var language = _a[_i];
            if (language['short'] !== this.userLanguage) {
                languageList.push(language['short']);
            }
            else if (language['short'] !== this.defaultLanguage) {
                languageList.push(language['short']);
            }
        }
        this.translate.addLangs(languageList);
        this.translate.use(this.userLanguage);
    };
    /**
     * Check if given language is valid
     * @param {string}    lang Language in short ('de') or long form ('de-DE')
     * @returns {boolean} True if valid
     */
    LanguageService.prototype.isValidLanguage = function (lang) {
        var result;
        if (lang && lang.length === 5) {
            result = _.find(this.validLanguages, ['long', lang]);
        }
        else if (lang && lang.length === 2) {
            result = _.find(this.validLanguages, ['short', lang]);
        }
        Logger.log(result);
        return result !== undefined && result !== null;
    };
    /**
     * Get language object
     * @param {string}     lang Language in short ('de') or long form ('de-DE')
     * @returns {Language} Language object
     */
    LanguageService.prototype.getLanguage = function (lang) {
        var result;
        if (lang && lang.length === 5) {
            result = _.find(this.validLanguages, ['long', lang]);
        }
        else if (lang && lang.length === 2) {
            result = _.find(this.validLanguages, ['short', lang]);
        }
        if (result && result !== undefined) {
            return result;
        }
        else {
            return null;
        }
    };
    /**
     * Returns the language in long form (e.g. de-DE)
     * @returns {string} Language as IETF language tag
     */
    LanguageService.prototype.getLongForm = function () {
        return this.currentLanguage.long;
    };
    /**
     * Returns the language in short form (e.g. de)
     * @returns {string} Language in ISO 639 form
     */
    LanguageService.prototype.getShortForm = function () {
        return this.currentLanguage.short;
    };
    /**
     * Returns the language in short form (e.g. Deutsch)
     * @returns {string} Language for displaying purposes
     */
    LanguageService.prototype.getDisplayedForm = function () {
        return this.currentLanguage.display;
    };
    /**
     * Returns a list with all valid languages
     * @returns {any[]} List with valid languages
     */
    LanguageService.prototype.getValidLanguages = function () {
        return this.validLanguages;
    };
    /**
     * Returns the locale settings depending on current language
     * @returns {LocaleSetting} Locale settings
     */
    LanguageService.prototype.getLocaleSpecificSettings = function () {
        switch (this.currentLanguage.long) {
            default:
            case 'de-DE': {
                return new LocaleSetting('.', ',', true, ' Mio.', 'DD.MM.');
            }
            case 'fr-FR': {
                return new LocaleSetting('.', ',', true, ' Mio.', 'DD/MM');
            }
            case 'en-US': {
                return new LocaleSetting(',', '.', true, 'm', 'MM/DD');
            }
            case 'en-GB': {
                return new LocaleSetting(',', '.', true, 'm', 'MM/DD');
            }
        }
    };
    return LanguageService;
}());
export { LanguageService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/language.service.ts.pre-build-optimizer.js